import { render, staticRenderFns } from "./MenuCamara.vue?vue&type=template&id=636e572f&scoped=true"
import script from "./MenuCamara.vue?vue&type=script&lang=js"
export * from "./MenuCamara.vue?vue&type=script&lang=js"
import style0 from "./MenuCamara.vue?vue&type=style&index=0&id=636e572f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "636e572f",
  null
  
)

export default component.exports